import React from "react";
import "./index.scss";
import Header from "../../appLayout/header";
import video from "../../../assets/videos/video.mp4";
import { useTranslation } from "../../../hooks/useTranslation";
const HeroSection = () => {
  const { t } = useTranslation();

  return (
    <>
      <Header />
      <section className="hero-section">
        <video autoPlay muted loop className="bg-video">
          <source src={video} type="video/mp4" />
        </video>

        <div className="overlay"></div>

        <div className="content">
          <h1>
            {t('heroTitle')}<br />{t('heroTitle2')}<br />{t('heroTitle3')}
          </h1>
          <p>
            {t('heroDescription')}
            <br />
            {t('heroDescription2')}
            <br />
            {t('heroDescription3')}
          </p>
        </div>
      </section>
    </>
  );
};

export default HeroSection;
